import { useState, useContext } from "react";
import { DataContextContractual } from "../../contextData/contextData";
import { CambioCargo } from "../cambio-de-cargo/CambioCargo";
import { useFormik } from "formik";
import { CambioDeInstalacion } from "../cambio-de-instalacion/cambioDeInstalacion";

export const  UseModalForm = () => {
  const [visible, setVisible] = useState(false);
  const { setTipoSolicitud } = useContext(DataContextContractual);
  const [dataModal, setDataModal] = useState({
    titulo: '---- ---------- ----',
    component: <div>esto es una prueba</div>
  })

  const hideModal = (llaveId) => {
    setVisible(!visible);
    setDataModal(objModal[llaveId ?? 0]);
    setTipoSolicitud(llaveId ?? 0);
  }

  const objModal = {
    0: {
      titulo: '',
      component: undefined
    },
    1: {
      titulo: "Cambio de cargo (SAP & Temporis)",
      component: <CambioCargo tipo={1} />
    },
    2: {
      titulo: "Cambio de unidad (Temporis)",
      component: <CambioCargo tipo={2} />
    },
    3: {
      titulo: "Cambio de instalación",
      component: <CambioCargo tipo={3} />
    },
    4: {
      titulo: "Estatus contrato de trabajo",
      component: <CambioCargo tipo={4} />
    },
    5: {
      titulo: "Solicitud de desvinculación del colaborador",
      component: <CambioCargo tipo={5} />
    },
  }

  const formik = useFormik({
    initialValues: {
      id_persona: '',
      id_tipo_solicitud: '',
      aprueba: true,
      cod_sap_jefe: '',
      cod_sap_nuevo_cargo: '',
      cod_sap_rrhh_responsable: '',
      cod_sap_jefe_unidad_destino: '',
      fecha_inicio_cambio: '',
      nuevo_temporis: '',
      nuevo_rol_temporis: '',
    }
  });

  return {
    visible, hideModal, dataModal, objModal, formik,
  }
}